<template>
    <div class="preview">
        <div>
            <div class="header text-center">
                <h1>Ét klik giver dig <span>meget mere indblik</span></h1>
            </div>

            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="card" @click="navigate(1)" :class="{active: slide === 1}">
                            <div class="card-body">
                                <div class="headline">
                                    Oversigt
                                </div>

                                <div>
                                    Få overblik ved at se udbyttet af din markedsføring, samlet antal besøg og henvendelser og dit omdømme - og find ud af, hvordan det går med din forretning.
                                </div>
                            </div>
                        </div>

                        <div class="card" @click="navigate(2)" :class="{active: slide === 2}">
                            <div class="card-body">
                                <div class="headline">
                                    SEO, Facebook, Google Ads
                                </div>

                                <div>
                                    Dyk dybere ned i din online markedsføring. Se udgifter og udbytte af din SEO, Google Ads, Facebook Ads og følg med i om det går bedre end sidste uge, måned og år.
                                </div>
                            </div>
                        </div>

                        <div class="card" @click="navigate(3)" :class="{active: slide === 3}">
                            <div class="card-body">
                                <div class="headline">
                                    Kampagner og resultater
                                </div>

                                <div>
                                    I de enkelte kanaler har du mulighed for at dykke helt ned i detaljerne. Se eksempelvis performance på enkelte kampagner og de tilknyttede annoncer.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-8">
                        <img :src="image" class="browser">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~bootstrap/scss/bootstrap.scss';

    .preview {
        position: relative;
        width: 100%;
        padding: 10vh 0;

        &:before {
            position: absolute;
            content: " ";
            background-color: #f7f7fb;
            z-index: 1;
            width: 100%;
            height: 80%;
            top: 20%;
            left: 0;
        }

        &:after {
            position: absolute;
            content: " ";
            background: url('/static/images/curve.svg');
            z-index: 1;
            width: 100%;
            height: 200px;
            background-size: cover;
            top: calc(20% - 200px);
            left: 0;
        }

        > div {
            position: relative;
            margin: 0 5vw;
            z-index: 5;

            * {
                z-index: 5;
            }

            .header {
                margin: 100px 0 80px 0;

                h1 {
                    font-weight: 200 !important;

                    span {
                        font-weight: 400;
                    }
                }
            }

            .card {
                cursor: pointer;
                overflow: hidden;
                border-radius: 5px;
                margin-bottom: 12px;
                box-shadow: 0 12px 40px rgba(0,0,0,0.08);

                border: 1px solid transparent;

                &:hover {
                    border: 1px solid #d6d6d6;
                }

                &.active {
                    border: 1px solid #bababa;
                    background-color: #f4f4f4;
                }

                .headline {
                    font-size: 18px;
                    font-weight: 200;
                    margin-bottom: 10px;
                }
            }

            .browser {
                max-width: 100%;
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                slide: 1
            }
        },

        computed: {
            image() {
                return '/static/images/switcher/browser_' + this.slide + '.png'
            }
        },

        methods: {
            navigate(slide) {
                this.slide = slide
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Preview.vue